import { ProtocolScope } from "@analysis/domain";

// These shapes now live in `@analysis/domain`, which owns them; re-exported here
// under their historical names so existing consumers keep working.
export { ProtocolScope };
export type { LabelCategory as Category, LabelOption as Option } from "@analysis/domain";

export const colors = [
  "#838600",
  "#ab1eb8",
  "#0032e1",
  "#009621",
  "#e07700",
  "#12ece0",
  "#ecbc12",
  "#e07d8a",
  "#a49395",
  "#58c8d3",
];

export const defaultColor = "#ff4646";

export interface ProtocolState {
  scope: ProtocolScope;
  methodTypeId: string | undefined;
}
